import { ComponentProps, ReactElement } from 'react';
import { parsePhoneNumber } from '@/utils';

import { RunPreviewInvoiceResponse } from '@/models/gen/graphql';
import SkyhopPdfFooter from '@/features/PdfLayout/components/SkyhopPdfFooter';
import { usePdfLayout } from '@/features/PdfLayout';

export type InvoicePdfFooterContactProps = ComponentProps<'ul'>;

const InvoicePdfFooterContact = ({ ...props }: InvoicePdfFooterContactProps): ReactElement => {
  const { invoicePhone } = usePdfLayout(({ state }: { state: { data: RunPreviewInvoiceResponse } }) => ({
    // Company
    invoicePhone: state?.data?.output?.company?.invoicePhone,
  }));

  return (
    <SkyhopPdfFooter.Section {...props}>
      {invoicePhone && (
        <>
          <SkyhopPdfFooter.SectionHeader>Phone</SkyhopPdfFooter.SectionHeader>
          <SkyhopPdfFooter.Item>Accounting Dept:</SkyhopPdfFooter.Item>
          <SkyhopPdfFooter.Item>{parsePhoneNumber(invoicePhone)}</SkyhopPdfFooter.Item>
        </>
      )}
    </SkyhopPdfFooter.Section>
  );
};

export default InvoicePdfFooterContact;
